export default __webpack_public_path__ + "static/media/background.721f6805.jpg";